import axios from "axios";
import { makeAutoObservable, runInAction, toJS } from "mobx";

import { callRemoteMethod } from "../utils/WebserviceHandler";
import CONSTANTS from "../utils/constants";
import User from "./UserStore";

import { ErrorWrapper } from "../utils/ErrorWrapper";
import moment from "moment";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { SuccessWrapper } from "../utils//SuccessMessage";
import General from '../../src/stores/GeneralStore'
import { makePersistable } from "mobx-persist-store";
import { NotifyError } from "../../src/utils/ShowError";
import { NotifySuccess } from "../../src/utils/ShowSuccess";
import { ErrorWrapperShow } from "../../src/utils/ErrorMessage";
interface NocsData {
  [key: string]: string | boolean | undefined;
}

interface Obj {
  [key: string]: any;
}

interface Noc {
  id: number;
  refNumber: string | null;
  submissionDate: string | null;
  accountNumber: string | null;
  requestType: string | null;
  sewerageNumber?: string | undefined;
  status?: string | null;
  nocReceipt?: string | null;
  cancellable?: boolean | null;
  typeDescription?: string | null;
  statusDescription?: string | null;
  userAssigned?:boolean | null;
}

interface Case {
  id: number;
  date: string | null;
  requestNumber: string | null;
  parcelNumber: string | null;
  totalDue: string | null;
  approvedAmount: string | undefined;
  status: string | null;
  statusId: Number | undefined;
}

interface CaseDetails {
  customerName: string | undefined;
  parcelNumber: string | undefined;
  applicationDateStr: any | undefined;
  status: any | undefined;
  customerAccount: any | undefined;
  personNumber: any | undefined;
  justification: any | undefined;
  emiratesId: string | undefined;
  tariffType: string | undefined;
  caseNo: string | undefined;
  totalDue: string | undefined;
  date: string;
  familyMember: string | undefined;
  socialStatus: string | undefined;
  comments: string | undefined;
  files: Obj[] | undefined;
  commentReply: string | undefined;
}

interface Payment {
  id: number;
  paymentPlanID: string | null;
  createdOn: string | null;
  numberOfCheques: string | null;
  status: string | null;
  amount: string | undefined;
}

interface PremiseSearchQueryParams {
  id: string;
  type: "tenant" | "owner" | "parcel";
}

type Charges = {
  amount: string;
  count: string;
};

export interface ChargesResult {
  connectionFees: Charges;
  serviceCharges: Charges;
  tenantFeeDues: Charges;
  nocCharge: Charges;
}

export interface PostNOCResponse {
  result: ChargesResult;
}
const notify = (message: any) => toast(message);
class NocsRequests {
  nocs: Noc[] = [];
  cases: Case[] = [];
  refundHistory: any[] = [];
  caseDetails: CaseDetails = {} as CaseDetails;
  payments: Payment[] = [];
  pdcDetails: Obj = {};

  serviceAccounts: Obj[] = [];
  connectorAccounts: Obj[] = [];

  trackRequestsList: Obj[] = [];
  createNocData: Obj = {};

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true, deep: true }); //persist

    makePersistable(this, {
      name: "nocrequests",
      properties: ["serviceAccounts", "connectorAccounts"],
      storage: window.localStorage,
    });
  }

  getValidNocs = ErrorWrapper(async () => {
    let res = await callRemoteMethod({ endpoint: CONSTANTS.URL.NOCS_REQUESTS });

    const temp = res.result;
    this.nocs = [];
    for (let i = 0; i < temp.length; i++) {
    
      this.nocs.push({
        id: temp[i]["id"],
        refNumber: temp[i]["caseId"],
        submissionDate: (temp[i]["createdDate"]),
        accountNumber: temp[i]["fieldValue"],
        requestType: temp[i]["nocType"],
        sewerageNumber: temp[i]["fieldValue"],
        status:temp[i]["status"],
        nocReceipt:temp[i]["nocReceipt"]
      });
    }
  });
 
  downloadNoc = ErrorWrapper(async (id: string) => {
    try {
      await axios.get(`${CONSTANTS.URL.BILL_PDF + id}`).then((res) => { });
    } catch (error) {
      console.log(error);
    }
  });

  getRecentRequests = ErrorWrapper(async () => {
    let res = await callRemoteMethod({ endpoint: CONSTANTS.URL.NOCS_REQUESTS });

    const temp = res.result;
    this.nocs = [];
    for (let i = 0; i < temp.length; i++) {
      console.log("link",temp[i]["nocReceipt"])
      this.nocs.push({
        id:temp[i]["id"],
        nocReceipt: temp[i]["nocReceipt"],
        refNumber: temp[i]["caseId"],
        submissionDate: temp[i]["createdDate"],
        accountNumber: temp[i]["fieldValue"],
        requestType: temp[i]["nocType"],
        status: temp[i]["status"],
       
       
      });
    }
  });

  downloadRecentRequest = ErrorWrapper(async () => {
    try {
      let res = await axios.get(CONSTANTS.URL.PAYMENT_PDF);
    } catch (err) {
      console.log(err);
    }
  });

  getPDCPaymentPlans = ErrorWrapper(async (personId: string) => {
    let res = await callRemoteMethod({
      endpoint: CONSTANTS.URL.ALL_PDCS + `/${personId}`,
    });

    const temp = res.result;
    this.payments = [];
    for (let i = 0; i < temp.length; i++) {
      this.payments.push({
        id: i + 1,
        paymentPlanID: temp[i]["caseNo"],
        createdOn: moment(temp[i]["createdDate"]).format("DD-MM-YYYY"),
        numberOfCheques: temp[i]["pdcCount"],
        status: temp[i]["statusName"],
        amount: Number(temp[i]["totalAmount"]).toFixed(2),
      });
    }
  });

  getSocialCases = ErrorWrapper(async (data: NocsData) => {
    if (!data.IsAll) data.IsAll = false;

    let res = await callRemoteMethod({
      endpoint: CONSTANTS.URL.SOCIAL_CASES,
      type: "GET",
      data: data,
    });
    const temp = res.result;
    this.cases = [];
    for (let i = 0; i < temp.length; i++) {
      this.cases.push({
        id: i + 1,
        date: moment(temp[i]["applicationDate"]).format("DD-MM-YYYY"),
        requestNumber: temp[i]["caseNo"],
        parcelNumber: temp[i]["parcelNumber"],
        totalDue: Number(temp[i]["amount"]).toFixed(2),
        approvedAmount: Number(temp[i]["approvedAmount"]).toFixed(2),
        status: temp[i]["status"],
        statusId: temp[i]["statusId"],
      });
    }
  });
  getRefundHistory = ErrorWrapper(async () => {

    let res = await callRemoteMethod({
      endpoint: CONSTANTS.URL.GET_REFUND_HISTORY(User.info.personId),
      type: "GET",
    });
    const temp = res?.result?.output?.adjustmentGroup;
    this.refundHistory = [];
    for (let i = 0; i < temp?.length; i++) {
      this.refundHistory.push({
        id: temp[i]["adjustmentId"],
        date: moment(temp[i]["creationDate"]).format('DD-MM-YYYY'),
        referenceNumber: temp[i]["adjustmentId"],
        totalDue: Number(temp[i]["adjustmentAmount"]).toFixed(2),
        status: temp[i]["adjustmentStatus"],
      });
    }
  });

  getCaseDetails = ErrorWrapper(async (id: string) => {
    let data = {
      CaseNo: id,
    };

    let res = await callRemoteMethod({
      endpoint: CONSTANTS.URL.SOCIAL_CASE_DETAILS,
      type: "GET",
      data,
    });
    console.log("***response", res);

    const temp = res.result;
    this.caseDetails = {
      customerName: temp["customerName"],
      parcelNumber: temp["parcelNumber"],
      justification: temp["justification"],
      status: temp["status"],
      customerAccount: temp["customerAccount"],
      emiratesId: temp["emiratesId"],
      personNumber: temp["personNumber"],
      applicationDateStr: temp["applicationDateStr"],
      tariffType: temp["tariffType"],
      caseNo: temp["caseNo"],
      totalDue: temp["dueAmount"],
      date: temp["applicationDate"],
      familyMember: temp["familyMember"],
      socialStatus: temp["socialStatus"],
      comments: temp["comments"],
      files: temp["files"],
      commentReply: temp["commentReply"],
    };
  });

  getPDCDetails = ErrorWrapper(async (caseNumber: string) => {
    let res = await callRemoteMethod({
      endpoint: CONSTANTS.URL.PDC_DETAILS + `/${caseNumber}`,
    });

    this.pdcDetails = res.result;
  });

  submitCaseDetails = ErrorWrapper(async (data: NocsData) => {
    let submitRes = await callRemoteMethod({
      endpoint: CONSTANTS.URL.CASE_DETAILS_SUBMIT,
      type: "POST",
      data,
    });
    let uploadRes = await callRemoteMethod({
      endpoint: CONSTANTS.URL.CASE_DETAILS_DOCUMENTS_UPLOAD,
      type: "POST",
      data,
    });
  });
  uploadNocDocs = ErrorWrapper(async (data: any) => {
    let uploadRes = await callRemoteMethod({
      endpoint: CONSTANTS.URL.NOC_OUTSIDE_DOCUMENTS_UPLOAD,
      type: "POST",
      data,
      file: true,
    });
  });
  getPDCServiceAccountList = ErrorWrapper(async (caseNo: string) => {
    const accountType: string = "SERVICE";

    this.serviceAccounts = [];
    const res = await callRemoteMethod({
      endpoint: CONSTANTS.URL.PDC_ACCOUNT_LIST(caseNo, accountType),
    });
    runInAction(() => {
      this.serviceAccounts = res.result;
    });
  });

  getPDCConnectorAccountList = ErrorWrapper(async (caseNo: string) => {
    const accountType: string = "CONNECTOR";

    this.connectorAccounts = [];
    const res = await callRemoteMethod({
      endpoint: CONSTANTS.URL.PDC_ACCOUNT_LIST(caseNo, accountType),
    });

    runInAction(() => {
      this.connectorAccounts = res.result;
     
    });
    
  });

  premiseSearch = ErrorWrapper(async (data: PremiseSearchQueryParams) => {
   
    try {
      const res= await callRemoteMethod({
        endpoint: CONSTANTS.URL.PREMISE_SEARCH,
        data,
      });
      return res;
    } catch (error:any) {
      if(error?.error[0]?.message?.includes('|')){
        const codedmsg= 'cm_'+error?.error[0]?.message?.split("|")?.[0].toLowerCase();
        const nocRequest=error?.error[0]?.message?.split("|")?.[3];
        const nocdays=error?.error[0]?.message?.split("|")?.[4];
        const premise=error?.error[0]?.message?.split("|")?.[1];
        const parcel=error?.error[0]?.message?.split("|")?.[2];
        const uodatedmsg=General?.codeLabels[codedmsg]?.label?.replace("%3",nocRequest)?.replace('%1',premise)?.replace("%2",parcel)?.replace('%4',nocdays);
         NotifyError(uodatedmsg)
      }else{
        NotifyError(General?.codeLabels['cm_invalidnumber']?.label)
      }
    
    }
  });
  deletePdc = ErrorWrapper(async (pdcId: string) => {
    var res = await callRemoteMethod({ endpoint: CONSTANTS.URL.DELETE_PDC(pdcId), type: 'GET' });
    // SuccessWrapper(res?.result?.message)
    if (res?.result?.output?.status=="S") {
      this.getPDCPaymentPlans({
        errorId: "getPDCPaymentPlansError",
        data: User.info.personId as string,
      })
      NotifySuccess(res?.result?.output?.statusMessage)
      // const res = await callRemoteMethod({ endpoint: CONSTANTS.URL.CARDS_LIST });
      // runInAction(() => { this.list = res.result })
    }
    return res;

  })
  postNocDue = ErrorWrapper(async (data: any) => {
    const dataBody = JSON.stringify({

      data,
      multiFileUpload: [
        {
          mediaType: "any",
          fileName: "any.jpg",
          buffer: ""
        }
      ]

    });


    const config = {
      method: "post",
      url: CONSTANTS.URL.NOC_DUE,
      headers: await getRequestHeader(),
      data: dataBody,
    };
    try {
      let response = await axios(config);
      return response.data;
    } catch (e: any) {
      const er = e?.response?.data?.error[0]?.message;
      ErrorWrapperShow(er);
    }
  });

  validateOutOfNetworkNOC = ErrorWrapper(async (data: any) => {
    const currentLanguage:any=localStorage?.getItem('settingUplanguage')
    const dataBody = JSON.stringify(data);
    const config = {
      method: "post",
      url: CONSTANTS.URL.VALIDATE_OUT_OF_NETWORK_NOC,
      headers: await getRequestHeader({ currentLanguage}),
      data: dataBody,
    };
    const response = await axios(config);
    if(response?.data?.result?.output?.status!="SUCCESS"){

      const resMsg = response?.data?.result?.output?.statusMsg
      if(resMsg=="CM_MULTIPLEIDFOUNDERR"){
        NotifyError(General?.codeLabels['cm_multipleidfounderr']?.label)
      }else{
        var msg1 = ""
        var msg2 = ""
        var msg3 = ""
        var msg4 = ""
        var finalMsg = ""
        if (resMsg?.split("|").length == 2) {
          msg2 = resMsg?.split("|")[1]
          msg1 = General?.codeLabels?.['cm_' + resMsg?.split("|")[0].toLowerCase()]?.label;
          if (msg1.includes('%1')) {
            finalMsg = msg1.replace(/%1/g, msg2)
          }
          NotifyError(finalMsg)
        } else if (resMsg?.split("|").length>3) {
          // msg2 = resMsg?.split("|")[1]
          // msg1 = General?.codeLabels?.['cm_' + resMsg?.split("|")[0].toLowerCase()]?.label; msg3 = resMsg?.split("|")[2]
          // NotifyError(msg1)
          msg2 = resMsg?.split("|")[1]
          msg3 = resMsg?.split("|")[2]
          msg4 = resMsg?.split("|")[3]
          msg1 = General?.codeLabels?.['cm_' + resMsg?.split("|")[0].toLowerCase()]?.label;
            finalMsg = msg1.replace(/%1/g, msg2)?.replace(/%2/g, msg3)?.replace(/%3/g,msg4)
          
          NotifyError(finalMsg)
        } else {
          msg1 = resMsg?.toLowerCase();
          NotifyError(General?.codeLabels?.[msg1]?.label?General?.codeLabels?.[msg1]?.label:"Invalid Request")
        }
      }
    }
   
    return response.data;
  });
  validateInsideNetworkNOC = ErrorWrapper(async (data: any) => {
    const config = {
      method: "GET",
      url: CONSTANTS.URL.VERIFY_OUTOFNETWORK_PARCEL(data),
      headers: await getRequestHeader({ currentLanguage: "en-US" }),
    };
    try{
      const response = await axios(config);
      return response.data;
    } catch (e: any) {
      const er = e?.response?.data?.error[0]?.message;
      ErrorWrapperShow(er);
    }
  });


  validateOutOfNetworkParcel = ErrorWrapper(async (data: any) => {
    const config = {
      method: "GET",
      url: CONSTANTS.URL.VERIFY_OUTOFNETWORK_PARCEL(data),
      headers: await getRequestHeader({ currentLanguage: "en-US" }),
    };
    const response = await axios(config);
    // notify(response?.data?.result?.output?.statusMsg);
    if(response?.data?.result?.output?.status==="INSIDE"){
      return response.data;
    }
    if(response?.data?.result?.output?.statusMsg!="MSG_92000_2901"){
      NotifyError(General?.codeLabels["cm_msg_92000_2902"]?.label)
    }
    
    return response?.data;
  });
  createOutOfNetworkNOC = ErrorWrapper(async (data: any) => {
    const data1 = { ...data, projectName: data?.project, parcelNumber: data?.parcelId ? data?.parcelId : null, propertyType: data?.propertyType ? data?.propertyType : null }
    const dataBody = JSON.stringify(data1);
    const response = await callRemoteMethod({
      endpoint: CONSTANTS.URL.CREATE_OUT_OF_NETWORK_NOC,
      type: "POST",
      data: dataBody,
    });
    // notify(response?.data?.result?.output?.statusMsg);
    runInAction(() => this.createNocData = response.result);
    return response;
  });

  getOutOfNetworkNOCBalance = ErrorWrapper(
    async ({ data, personId }: { data: any; personId: string }) => {
      let headers = await getRequestHeader({ currentLanguage: "en-US" });

      let res = (await axios.get(CONSTANTS.URL.VIEW_PROFILE(personId), {
        headers,
      })) as any;


      let { mobileNumber, email, name } = res.data.result;
      // const dataBody = JSON.stringify({
      //   ...data,
      //   mobilePhoneNumber: mobileNumber,
      //   email,
      //   name,
      // });
      const dataBody = JSON.stringify({
        caseId: data,
      });

      const config = {
        method: "post",
        url: CONSTANTS.URL.GET_OUT_OF_NETWORK_NOC_BALANCE,
        headers,
        data: dataBody,
      };
      let response = await axios(config);
      return response.data;
    }
  );
  getOutOfNetworkNOCBalanceTest = ErrorWrapper(async (data: any) => {
    const res = await callRemoteMethod({
      endpoint: CONSTANTS.URL.GET_OUT_OF_NETWORK_NOC_BALANCE,
      type: "POST",
      data,
    });
    return res;
  })
  makeNOCPayment = ErrorWrapper(
    async (incomingDate: {
      nocTypeSelected: string;
      nocRefID: string;
      amount: number;
      token: string;
      paymentRequestType:string;
      fewaRegistrationFlag: boolean;
      nocAppliedNo: string;
      type:string;
      tenancyContractExpiryDate:string;
    }) => {
      const data = {
        ...incomingDate,
        platform: "Web",
      };

      const res = await callRemoteMethod({
        endpoint: CONSTANTS.URL.NOC_PAYMENT,
        type: "POST",
        data,
      });
      return res;
    }
  );
   makeNINOCPayment = ErrorWrapper(
    async (incomingDate: any) => {
      const data = {
        ...incomingDate,
        platform: "Web",
      };

      const res = await callRemoteMethod({
        endpoint: CONSTANTS.URL.NI_NOC_PAYMENT,
        type: "POST",
        data,
      });
      return res;
    }
  );
   makeTabbyNOCPayment = ErrorWrapper(
    async (incomingDate: any) => {
      const data = {
        ...incomingDate,
        platform: "Web",
      };

      const res = await callRemoteMethod({
        endpoint: CONSTANTS.URL.TABBY_NOC_PAYMENT,
        type: "POST",
        data,
      });
      return res;
    }
  );

   makeTamaraNOCPayment = ErrorWrapper(
    async (incomingDate: any) => {
      const data = {
        ...incomingDate,
        platform: "Web",
      };

      const res = await callRemoteMethod({
        endpoint: CONSTANTS.URL.TAMARA_NOC_PAYMENT,
        type: "POST",
        data,
      });
      return res;
    }
  );


  makeNOCOutsidePayment = ErrorWrapper(
    async (incomingDate: {
      nocTypeSelected: string;
      nocRefID: string;
      amount: number;
      token: string;
      paymentRequestType:string;
      fewaRegistrationFlag: boolean;
      nocAppliedNo: string;
      type:string;
      email:string;
      nocType:string;
    }) => {
      const data = {
        ...incomingDate,
        platform: "web",
      };

      const res = await callRemoteMethod({
        endpoint: CONSTANTS.URL.NOC_OUTSIDE_PAYMENT,
        type: "POST",
        data,
      });
      return res;
    }
  );
   makeNINOCOutsidePayment = ErrorWrapper(
    async (incomingDate: any) => {
      const data = {
        ...incomingDate,
        platform: "web",
      };

      const res = await callRemoteMethod({
        endpoint: CONSTANTS.URL.NI_NOC_OUTSIDE_PAYMENT,
        type: "POST",
        data,
      });
      return res;
    }
  );
  makeTabbyNOCOutsidePayment = ErrorWrapper(
    async (incomingDate: any) => {
      const data = {
        ...incomingDate,
        platform: "web",
      };

      const res = await callRemoteMethod({
        endpoint: CONSTANTS.URL.TABBY_NOC_OUTSIDE_PAYMENT,
        type: "POST",
        data,
      });
      return res;
    }
  );

   makeTamaraNOCOutsidePayment = ErrorWrapper(
    async (incomingDate: any) => {
      const data = {
        ...incomingDate,
        platform: "web",
      };

      const res = await callRemoteMethod({
        endpoint: CONSTANTS.URL.TAMARA_NOC_OUTSIDE_PAYMENT,
        type: "POST",
        data,
      });
      return res;
    }
  );

  makeTabbyEligibilityCheck =ErrorWrapper(
  async (incomingDate: any) => {
    const data = {
      ...incomingDate,
      platform: "Web",
    };

    const res = await callRemoteMethod({
      endpoint: CONSTANTS.URL.TABBY_ELIGIBILITY,
      type: "POST",
      data,
    });
    return res;
  }
);

makeTamaraEligibilityCheck =ErrorWrapper(
  async (incomingDate: any) => {
    const data = {
      ...incomingDate,
      platform: "Web",
    };

    const res = await callRemoteMethod({
      endpoint: CONSTANTS.URL.TAMARA_ELIGIBILITY,
      type: "POST",
      data,
    });
    return res;
  }
);


getTrackRequestStatus=ErrorWrapper(async(data:any)=>{
  const {trackId}=data;
  const res = await callRemoteMethod({
    endpoint: CONSTANTS.URL.TRACK_REQUESTS_STATUS(trackId),
    type: "GET",
  });
  console.log(res);
  return res;
})
  getTrackRequests = ErrorWrapper(
    async ({ from, to }: { from: string; to: string }) => {
      const data = {
        startDate: from,
        endDate: to,
      };

      const res = await callRemoteMethod({
        endpoint: CONSTANTS.URL.TRACK_REQUESTS,
        type: "GET",
        data,
      });
      const temp = res.result;
      this.nocs = [];
      for (let i = 0; i < temp.length; i++) {
      
        this.nocs.push({
          id: i + 1,
          refNumber: temp[i]["id"],
          submissionDate: moment(temp[i]["submittedDate"])?.format('DD-MM-YYYY'),
          accountNumber: temp[i]["fieldValue"],
          requestType: temp[i]["type"],
          sewerageNumber: temp[i]["fieldValue"],
          status:temp[i]["status"],
          nocReceipt:temp[i]["nocReceipt"],
          cancellable:temp[i]["cancellable"],
          typeDescription:temp[i]["typeDescription"],
          statusDescription:temp[i]["statusDescription"],
          userAssigned:temp[i]["userAssigned"]



        });
      }
      runInAction(() => {
        this.trackRequestsList = res.result;
      });
      return res;
    }
  );
  getServiceCancelationRequest = ErrorWrapper(async (id: string) => {
    const res = await callRemoteMethod({
      endpoint: CONSTANTS.URL.SERVICE_CANCELATION_REQUEST(id),
      type: "POST",
    });
    return res?.result;
  });
  getMoveInRegistrationDetails = ErrorWrapper(async (data: string) => {
    const {caseId,tenantPersonId}=data as any
    const res = await callRemoteMethod({
      endpoint: CONSTANTS.URL.GET_MOVEIN_REGISTRATION_DETAILS(caseId,tenantPersonId),
      type: "POST",
    });
    return res?.result;
  });
  getMoveinRequestUpdation = ErrorWrapper(async (data: any) => {
    const res = await callRemoteMethod({
      endpoint: CONSTANTS.URL.MOVEINREQUESTUPDATION,
      type: "POST",
      data,
    });
    return res?.result;
  });
  uploadDocumentsForMoveinRequestUpdation = ErrorWrapper(async (data: any) => {
    let uploadRes = await callRemoteMethod({
      endpoint: CONSTANTS.URL.UPLOAD_DOCUMENTS_MOVEIN_REQUEST_UPDATION,
      type: "POST",
      data,
    });
    return uploadRes?.result;
  });
  downloadMoveinDocument = ErrorWrapper(async (data: any) => {
    const { documentName, caseId} = data;
    let { info } = await User;
    try {
      const headers = new Headers();
      if (info.token) {
        headers.append("Authorization", `Bearer ${info.token}`);
      }

      const response = await fetch(CONSTANTS.URL.DOWNLOAD_MOVEIN_DOCUMENT(documentName, caseId), {
        method: "GET",
        headers: headers,
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const blob = await response.blob();

      // Create a URL for the blob data
      const blobUrl = URL.createObjectURL(blob);

      // Create an invisible link to trigger the download
      const a = document.createElement("a");
      a.href = blobUrl;
      a.download = documentName || "downloaded-file";
      a.style.display = "none";
      document.body.appendChild(a);

      // Trigger the click event on the link
      a.click();

      // Remove the link element
      document.body.removeChild(a);
    } catch (error) {
      console.error("Error downloading the file: ", error);
    }
  });
  deleteMoveinDocument = ErrorWrapper(async (data: any) => {
    const { documentName, caseId} = data;
    const res = await callRemoteMethod({
      endpoint: CONSTANTS.URL.DELETE_MOVEIN_DOCUMENT(documentName, caseId),
      type: "DELETE",
    });
    // if (res?.result?.output?.status == "S") {
    //   NotifySuccess(res?.result?.output?.statusMessage)
    // }
    return res;
  });
  getCaseReasons = ErrorWrapper(async (data:any) => {
    // The endpoint is a function that needs reasonCodes parameter
    const endpoint = CONSTANTS.URL.REQUEST_UPDATE_CASEREASONS(data);
    let res = await callRemoteMethod({
      endpoint: endpoint,
      type: "GET",
    });
    return res?.result;
  });
}

async function getRequestHeader(options = { currentLanguage: "en-us" }) {
  let { info } = await User;
  var header = {
    Accept: `application/json`,
    "Content-Type": `application/json`,
    currentLanguage: options.currentLanguage,
    Authorization: `${localStorage.getItem("serviceToken")}`,
    CurrentLanguage: localStorage.getItem("settingUplanguage") ?? "en-US"
  };
  info.token && (header.Authorization = `Bearer ${info.token}`);

  return header;
}

const nocsRequestsStore = new NocsRequests();
export default nocsRequestsStore;
